// 広告着地時に退避した流入情報（twclid/utm_* 等）の読み取りヘルパー。
// public/index.html の早期キャプチャスクリプトが cookie(tk_attrib) と
// localStorage(tk_attrib) の両方へ JSON を保存する。SPA リダイレクトで URL
// クエリが消えても、ここから復元して X/GA4 の計測に流し込めるようにする。

const STORAGE_KEY = 'tk_attrib';

const isBrowser = (): boolean => typeof window !== 'undefined' && typeof document !== 'undefined';

// cookie から tk_attrib を取り出す。無ければ null。
const readAttributionCookie = (): string | null => {
  if (!isBrowser()) return null;
  const match = document.cookie.match(/(?:^|; )tk_attrib=([^;]*)/);
  return match ? decodeURIComponent(match[1]) : null;
};

// localStorage から tk_attrib を取り出す。無ければ null。
const readAttributionStorage = (): string | null => {
  if (!isBrowser()) return null;
  try {
    return window.localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
};

const parseAttribution = (raw: string | null): Record<string, string> | null => {
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw);
    if (parsed && typeof parsed === 'object') {
      return parsed as Record<string, string>;
    }
  } catch {
    // 壊れた JSON は無視してフォールバックへ回す。
  }
  return null;
};

// cookie 優先、失敗時は localStorage フォールバック。どちらも失敗なら {}。
// 計測経路で呼ばれるため絶対に throw しない。
export const getStoredAttribution = (): Record<string, string> => {
  if (!isBrowser()) return {};
  return (
    parseAttribution(readAttributionCookie()) ??
    parseAttribution(readAttributionStorage()) ??
    {}
  );
};

export const getStoredTwclid = (): string => getStoredAttribution().twclid || '';
